/**
 * @module linkage/chartTypeSwitch/prepareConfigForChartType
 * @description 切图 L2 校正（prepareConfigForChartType）
 */

import PANEL_LAYOUT_BY_CHART, {
  layoutToResolvedGroups,
} from '../../manifest/panelLayout';
import { buildQBSnapshotFromColumns } from '../../services/api-upload/qbSnapshot';
import { normalizeRecord } from '../../services/api-upload/normalize';
import type { IPrepareConfigInput } from '../../services/api-upload/types';
import { evaluateVisibility } from '../../manifest/visibility/evaluateVisibility';
import {
  reconcileConfigForChartType,
  type IReconcileChartTypeResult,
} from './reconcileForChartType/index';

export type { IPrepareConfigInput } from '../../services/api-upload/types';

export interface IPrepareConfigOutput extends IReconcileChartTypeResult {
  formDelKey: Record<string, boolean>;
  hasDraft: Record<string, boolean>;
}

export function prepareConfigForChartType(
  input: IPrepareConfigInput,
): IPrepareConfigOutput {
  const base = normalizeRecord(input.base);
  const draft = normalizeRecord(input.draft);
  const hasDraft = normalizeRecord(input.hasDraft) as Record<string, boolean>;

  const qb = buildQBSnapshotFromColumns({ ...input, base, draft });
  const reconciled = reconcileConfigForChartType(
    input.chartType,
    qb,
    base,
    draft,
  );

  const tabs = PANEL_LAYOUT_BY_CHART[input.chartType] ?? [];
  const { formDelKey } = evaluateVisibility(
    qb,
    layoutToResolvedGroups(input.chartType, tabs),
  );

  return {
    ...reconciled,
    formDelKey,
    hasDraft,
  };
}
